import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useUnitConnectorColors } from '../../../hooks/useUnitConnectorColors';

interface Props {
  type: DashboardConnectorType;
}

export const ShortConnector: FC<Props> = ({ type }) => {
  const connectorColors = useUnitConnectorColors();
  const shortConnectors = {
    locked: (
      <svg width="270" height="111" viewBox="0 0 270 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 56C0 51.5817 3.58172 48 8 48H270V55C270 59.4183 266.418 63 262 63H0V56Z" fill="#EBE4DC" />
        <path
          d="M15 48.1431L15 111L2.38339e-07 111L2.52723e-06 56.1431C2.71158e-06 51.7248 3.58172 48.1431 8 48.1431L15 48.1431Z"
          fill="#EBE4DC"
        />
        <path
          d="M270 0L270 54.8572C270 59.2754 266.418 62.8572 262 62.8572L255 62.8572L255 -6.55671e-07L270 0Z"
          fill="#EBE4DC"
        />
        <ellipse cx="262.5" cy="55.5" rx="7.5" ry="7.5" transform="rotate(-180 262.5 55.5)" fill="#BAAF9F" />
        <ellipse cx="7.5" cy="55.5" rx="7.5" ry="7.5" transform="rotate(-180 7.5 55.5)" fill="#BAAF9F" />
      </svg>
    ),
    unlocked: (
      <svg width="270" height="111" viewBox="0 0 270 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_2169_36997" fill="white">
          <path d="M0 56C0 51.5817 3.58172 48 8 48H270V55C270 59.4183 266.418 63 262 63H0V56Z" />
        </mask>
        <path
          d="M0 56C0 49.3726 5.37258 44 12 44H270V52H8C3.58172 52 0 53.7909 0 56ZM270 55C270 61.6274 264.627 67 258 67H0V59H262C266.418 59 270 57.2091 270 55ZM270 55M0 63V48V63M0 63M270 48V63V48"
          className={connectorColors.fillBase}
          mask="url(#path-1-inside-1_2169_36997)"
        />
        <mask id="path-3-inside-2_2169_36997" fill="white">
          <path d="M15 48.1431L15 111L2.38339e-07 111L2.52723e-06 56.1431C2.71158e-06 51.7248 3.58172 48.1431 8 48.1431L15 48.1431Z" />
        </mask>
        <path
          d="M19 48.1431L19 111L11 111L11 48.1431L19 48.1431ZM-4 111L-4 60.1431C-4 53.5156 1.37259 48.1431 8 48.1431C5.79086 48.1431 4 51.7248 4 56.1431L4 111L-4 111ZM4 111M2.86102e-06 48.1431L15 48.1431L2.86102e-06 48.1431M2.86102e-06 48.1431M15 111L2.38339e-07 111L15 111"
          className={connectorColors.fillBase}
          mask="url(#path-3-inside-2_2169_36997)"
        />
        <mask id="path-5-inside-3_2169_36997" fill="white">
          <path d="M270 0L270 54.8572C270 59.2754 266.418 62.8572 262 62.8572L255 62.8572L255 -6.55671e-07L270 0Z" />
        </mask>
        <path
          d="M274 1.74846e-07L274 50.8572C274 57.4846 268.627 62.8572 262 62.8572C264.209 62.8572 266 59.2754 266 54.8572L266 -1.74846e-07L274 1.74846e-07ZM251 62.8572L251 -8.30516e-07L259 -4.80825e-07L259 62.8572L251 62.8572ZM259 62.8572M255 -6.55671e-07L270 0L255 -6.55671e-07M255 -6.55671e-07M270 62.8572L255 62.8572L270 62.8572"
          className={connectorColors.fillBase}
          mask="url(#path-5-inside-3_2169_36997)"
        />
        <ellipse
          cx="262.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 262.5 55.5)"
          className={connectorColors.fillAccent}
        />
        <ellipse
          cx="7.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 7.5 55.5)"
          className={connectorColors.fillAccent}
        />
      </svg>
    ),
    passed: (
      <svg width="270" height="111" viewBox="0 0 270 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 56C0 51.5817 3.58172 48 8 48H270V55C270 59.4183 266.418 63 262 63H0V56Z"
          className={connectorColors.fillBase}
        />
        <path
          d="M15 48.1431L15 111L2.38339e-07 111L2.52723e-06 56.1431C2.71158e-06 51.7248 3.58172 48.1431 8 48.1431L15 48.1431Z"
          className={connectorColors.fillBase}
        />
        <path
          d="M270 0L270 54.8572C270 59.2754 266.418 62.8572 262 62.8572L255 62.8572L255 -6.55671e-07L270 0Z"
          className={connectorColors.fillBase}
        />
        <ellipse
          cx="262.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 262.5 55.5)"
          className={connectorColors.fillAccent}
        />
        <ellipse
          cx="7.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 7.5 55.5)"
          className={connectorColors.fillAccent}
        />
      </svg>
    ),
  };

  return shortConnectors[type];
};
